// Module
var code = `<div class="objectManagerScreen">
    <panelsContainerControl forcedSelectedPanel="{{forcedSelectedPanel}}" on-activePanelChange="onActivePanelChange">
        <indicatorsManagerPanel attached="{{dockablePanel}}"/>
        <drawingsManagerPanel attached="{{dockablePanel}}"/>
        <overlaysManagerPanel attached="{{dockablePanel}}"/>
    </panelsContainerControl>
</div>`;
// Exports
export default code;